import { create } from "zustand";

export interface QuotationItem {
  quotationId: string;
  quotationNumber: string;
  caseId: string;
  caseNumber: string;
  quotationStatus: string;
  isManual: boolean;
  claimId: string;
  claimant: {
    title: string;
    first_name: string;
    last_name: string;
    identification_type: string;
    identification_number: string;
    contact_number: string;
    email: string;
  };

  deceased: {
    title?: string;
    initials?: string;
    first_name: string;
    last_name: string;
    relationship?: string;
    date_of_birth?: string;
    date_of_death: string;
    cause_of_death?: string;
    identification_number: string;
    identification_type?: string;
  };

  allocationDetails: {
    message: string;
    bodyRemovalNumber: string;
    caseNumber: string;
    status: string;
    driverName: string;
    driverPhone: string;
    vehicleNumber: string;
    vehicleType: string;
    expectedPickupDate: string;
    expectedPickupTime: string;
    contactPersonAtLocation: string;
    contactNumber: string;
    assignedBy: string;
  };

  bodyRemoval?: any;

  funeralPackageSourceType?: "MANUAL" | "POLICY";
  subtotal?: number;
  vatAmount?: number;
  totalAmount?: number;
  benefitSelections?: any[];
  // Services saved on the quotation (shape may vary by backend casing).
  quotationLineItems?: any[];

  documentResponseDtoList: {
    document_id: string;
    document_type: string;
    file_url: string;
    file_name: string;
  }[];

  createdAt: string;
  updatedAt: string;
}

interface QuotationState {
  quotations: QuotationItem[];
  totalElements: number;
  statusCounts: Record<string, number>;
  selectedQuotation: QuotationItem | null;

  setQuotations: (data: any) => void;
  setSelectedQuotation: (item: QuotationItem) => void;
  clearSelectedQuotation: () => void;
}

export const useQuotationStore = create<QuotationState>((set) => ({
  quotations: [],
  totalElements: 0,
  statusCounts: {},
  selectedQuotation: null,

  setQuotations: (data) =>
    set({
      quotations: data?.quotations || [],
      totalElements: data?.totalCount || 0,
      statusCounts: data?.statusCounts || {},
    }),

  setSelectedQuotation: (item) =>
    set({
      selectedQuotation: item,
    }),

  clearSelectedQuotation: () =>
    set({
      selectedQuotation: null,
    }),
}));
